import { render, staticRenderFns } from "./ProductRevenueReport.vue?vue&type=template&id=47274a56&scoped=true"
import script from "./ProductRevenueReport.vue?vue&type=script&lang=js"
export * from "./ProductRevenueReport.vue?vue&type=script&lang=js"
import style0 from "./ProductRevenueReport.vue?vue&type=style&index=0&id=47274a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47274a56",
  null
  
)

export default component.exports